import type { Category, Product } from '@bazaar/shared';

export interface CategoryWithCount extends Category {
  productCount: number;
}

/**
 * Merges the categories list with a live product count computed from the
 * currently-loaded products list, so the admin Categories screen's counts
 * stay in sync with edits made on the Products screen without needing to
 * re-fetch `/api/categories` (which also returns a `productCount`, but only
 * as of its own last fetch).
 */
export function mergeCategoryProductCounts(categories: Category[], products: Product[]): CategoryWithCount[] {
  const counts = new Map<number, number>();
  for (const product of products) {
    if (product.categoryId === null) continue;
    counts.set(product.categoryId, (counts.get(product.categoryId) ?? 0) + 1);
  }
  return categories.map((category) => ({ ...category, productCount: counts.get(category.id) ?? 0 }));
}
